<template>
  <div>
    <div class="header_index_nav" 
        :class="{active_t: lockTop}">
      <div class="sticky-wrapper" style="height: auto;"></div>
      <header>
        <div class="index_nav">
          <div class="nav_box">
            <div class="nav_flex">
              <div class="nav_logo_w"></div>
              <div class="nav_li">
                <div class="nav_li_text">关于我们</div>
                <div class="nav_li_text">社会责任</div>
                <div class="nav_li_text">新闻动态</div>
                <div class="nav_li_text">投资者关系</div>
                <div class="nav_li_text">加入我们</div>
              </div>
            </div>
          </div>
        </div>
        <!--移动端导航-->
        <div class="mobile_index_nav">
          <div class="nav_logo_w"></div>
          <i class="iconfont icon-website-caidan"></i>
        </div>
        <!--移动端导航展开-->
        <div class="mobile_open_nav">
          <div class="m_open_logo">
            <div class="nav_logo_w"></div>
            <i class="iconfont icon-website-guanbi"></i>
          </div>
          <div class="m_open_list">
            <div class="m_list_text">关于我们</div>
            <div class="m_list_text">社会责任</div>
            <div class="m_list_text">新闻动态</div>
            <div class="m_list_text">投资者关系</div>
            <div class="m_list_text">加入我们</div>
          </div>
        </div>
      </header>
    </div>
    <main ref="containerDiv" class="index_main_content">
      <!--首页视频-->
      <section class="index_video_section" data-wg="" style="background-color:#000000" data-mb-image="">
        <video loop="" muted="" autoplay="" playsinline="" poster="" class="index_video">
            <source src="../../assets/video/kingsoft.mp4" type="video/mp4">
        </video>
        <div class="index_video_text">
          <div class="video_title">梦想金山</div>
          <i class="iconfont icon-website-xiangxia hvr-hang"></i>
        </div>
      </section>

      <!--首页内容-->
      <div class="index_main_body">
        <div class="zcgy_img">
          <img src="../../assets/img/zcgy_nav.png">
          <div class="mask_bg"></div>
        </div>
        <div class="zcgy_word">
          <div class="zcgy_ch">志存高远 脚踏实地</div>
          <div class="zcgy_en">Keep high aspirations with feet on the ground</div>
        </div>
      </div>
      <div class="index_flex_layout">
        <div class="index_three_width">
          <div class="index_text_layout">
            <div class="text_title">技术立业</div>
            <div class="text_word">程序员是老大</div>
            <div class="index_se_hover_box">
              <img src="../../assets/img/002.jpg">
              <div class="index_se_title">技术立业</div>
            </div>
          </div>
          <div class="index_text_layout">
            <div class="text_title">梦想</div>
            <div class="text_word">人因梦想而伟大</div>
            <div class="index_se_hover_box">
              <img src="../../assets/img/002.jpg">
              <div class="index_se_title">梦想</div>
            </div>
          </div>
          <div class="index_text_layout">
            <div class="text_title">兄弟抱团打天下</div>
            <div class="text_word">创业路上，一个人可以走的更快<br>但是一群人可以走的更远</div>
            <div class="index_se_hover_box">
              <img src="../../assets/img/002.jpg">
              <div class="index_se_title">兄弟抱团打天下</div>
            </div>
          </div>
        </div>
        <div class="index_news_layout">
          <div class="in_news_top">
            <img src="../../assets/img/mxjs_nav.png">
            <div class="in_news_hover_bg">
              <div class="news_hover_title">新闻大标题新闻大标题</div>
              <div class="news_hover_word">这是一个新闻，这里放新闻的简介内容，多少字合适呢，那就看看效果再说吧啦啦啦啦，在多写几句吧就这样吧差不多了</div>
              <i class="iconfont icon-website-xiangyou"></i>
            </div>
          </div>
          <div class="in_news_bottom">
            <div class="in_news_list">
              <img src="../../assets/img/mxjs_nav.png">
              <div class="in_news_hover_bg">
                <div class="news_hover_title">新闻大标题新闻大标题</div>
                <div class="news_hover_word">这是一个新闻，这里放新闻的简介内容，多少字合适呢，那就看看效果再说吧啦啦啦啦，在多写几句吧就这样吧差不多了</div>
                <i class="iconfont icon-website-xiangyou"></i>
              </div>
            </div>
            <div class="in_news_list">
              <img src="../../assets/img/mxjs_nav.png">
              <div class="in_news_hover_bg">
                <div class="news_hover_title">新闻大标题新闻大标题</div>
                <div class="news_hover_word">这是一个新闻，这里放新闻的简介内容，多少字合适呢，那就看看效果再说吧啦啦啦啦，在多写几句吧就这样吧差不多了</div>
                <i class="iconfont icon-website-xiangyou"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index_main_body2">
        <div class="zcgy_img"><img src="../../assets/img/mxjs_nav.png"><div class="mask_bg"></div></div>
        <div class="zcgy_word">
          <div class="zcgy_ch">梦想金山</div>
          <div class="zcgy_en">Dreams Never Lost at Kingsoft</div>
        </div>
      </div>
    </main>
    <footer class="index_footer">
      <div class="index_footer_layout">
        <div class="in_footer_top">
          <div class="footer_logo"><img src="../../assets/img/kslogo.png"></div>
          <div class="footer_nav">
            <div>关于我们</div>
            <div>社会责任</div>
            <div>新闻动态</div>
            <div>投资者关系</div>
            <div>加入我们</div>
          </div>
          <div class="footer_follow">
            <div class="follow_title">关注我们</div>
            <i class="iconfont icon-website-weixin hvr-fade"></i>
            <i class="iconfont icon-website-weibo hvr-fade"></i>
            <i class="iconfont icon-website-yutube hvr-fade"></i>
          </div>
        </div>
        <div class="in_footer_company">
          <div>金山办公</div>
          <div>西山居</div>
          <div>金山云</div>
          <div>金山世游</div>
        </div>
        <div class="in_footer_copyright">
          <span>京公网安备11010802025727（总）</span>      
          <span>网出证（京）字第168号</span>      
          <span>京网文【2014】0937-238号</span>      
          <span>京ICP备06025896-1号</span>
          <span><img src="../../assets/img/kxlogo.png"></span>
        </div>
        <div class="backup hvr-hang">
          <i class="iconfont icon-website-backup"></i>
        </div>
      </div>
    </footer>
    
    
  </div>
</template>
<script>

export default {
  name: 'ks-index',
  components:{},
  props: {
    
  },

  data () {
    return {
      lockTop:false
      
    }
  },
  computed:{
    
  },
  methods:{
    
    handleScroll(){
      //获取dom滚动距离
      const scrollTop = document.documentElement.scrollTop;
      //获取可视区高度
      const offsetHeight = document.documentElement.offsetHeight;
      //获取滚动条总高度
      const scrollHeight = document.documentElement.scrollHeight;

      const winHeight = document.documentElement.clientHeight;
      if(scrollTop >= (winHeight - 64)){
        this.lockTop = true;
      }else{
        this.lockTop = false;
      }

    }
  },
  watch:{
    
  },
  methods:{
    getScrollTop(){
      let scrolltop = 0;
      if(document.documentElement && document.documentElement.scrollTop){
        scrolltop = document.documentElement.scrollTop;
      }else if(document.body){
         scrolltop = document.body.scrollTop;
      }
      return scrolltop;
    },
  },
  mounted(){
    window.addEventListener("scroll", this.handleScroll);
    // this.$nextTick(() => {
    //   //监听这个dom的scroll事件
    //   this.$refs.containerDiv.addEventListener("scroll", this.handleScroll);
    // });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_website.less';
    @import '../../assets/css/ks_website_m.less';
    @import '../../assets/fonts/iconfont.css';
</style>
